export * from './IconChatStroked';
